'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _VisitorActionTypes = require('../constants/VisitorActionTypes');

var ActionTypes = _interopRequireWildcard(_VisitorActionTypes);

var _addMessageToStubbedThread = require('../stubbed-thread-history/actions/addMessageToStubbedThread');

var _SupplementalInitialMessagesActions = require('../actions/SupplementalInitialMessagesActions');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessage = (0, _getIn2.default)(['message']);

var SupplementalInitialMessageMiddleware = function SupplementalInitialMessageMiddleware(store) {
  return function (next) {
    return function (action) {
      switch (action.type) {
        case ActionTypes.INITIAL_MESSAGE_STAGED:
          {
            var isBot = (0, _getIn2.default)(['payload', 'isBot'], action);

            if (isBot) {
              store.dispatch((0, _SupplementalInitialMessagesActions.fetchSupplementalInitialMessages)());
            }
            break;
          }

        case ActionTypes.GET_SUPPLEMENTAL_INITIAL_MESSAGES_SUCCEEDED:
          {
            var supplementalInitialMessages = action.payload.supplementalInitialMessages;


            supplementalInitialMessages.forEach(function (messageContainer) {
              var message = getMessage(messageContainer);
              store.dispatch((0, _addMessageToStubbedThread.addMessageToStubbedThread)(message));
            });
            break;
          }

        default:
          break;
      }

      return next(action);
    };
  };
};

exports.default = SupplementalInitialMessageMiddleware;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/middleware/SupplementalInitialMessageMiddleware.js
// module id = 844
// module chunks = 2 3